import store from '../store'
import ru from '../locales/ru.json'
import uk from '../locales/uk.json'

const locales = {
  'ru_RU': ru,
  'uk_UA': uk,
}

export default {
  install(Vue){
    Vue.prototype.$messageLocalized = function (key){
      const locale = store.getters.locale || 'uk_UA'
      return this.$bvModal.msgBoxOk(locales[locale][key] || key, {
        centered: true
      })
    }
    Vue.prototype.$toastLocalized = function (key){
      const locale = store.getters.locale || 'uk_UA'
      return this.$bvToast.toast(locales[locale][key] || key, {
        toaster: 'b-toaster-top-center',
        autoHideDelay: 120000,
        solid: true,
        bottom: false
      })
    }
    Vue.prototype.$logoutMessage = function(text){
      return this.$bvToast.toast(text, {
        toaster: 'b-toaster-top-center',
        autoHideDelay: 120000,
        solid: true,
        bottom: false
      }) 
    }
  }
}